import * as React from 'react';
import type { Granularity } from '@ooh/screens';

export interface InventoryViewState {
  showMonthColumns: boolean;
  setShowMonthColumns: (v: boolean) => void;
  granularity: Granularity;
  setGranularity: (v: Granularity) => void;
}

export function useInventoryViewState(): InventoryViewState {
  const [showMonthColumns, setShowMonthColumns] = React.useState(false);
  const [granularity, setGranularity] = React.useState<Granularity>('month');

  return {
    showMonthColumns,
    setShowMonthColumns,
    granularity,
    setGranularity,
  };
}
